module.exports = __webpack_public_path__ + "static/media/more-options-question.b80dd0f5.svg";